import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { ResponseStatus } from '../../../../shared';
import { LoggingService } from '../../../../shared/services/logging';
import { EfaactDataService } from '../../../efaact.data-service';
import { InvoiceSetup } from './invoice-setup.model';

export const entityName = 'InvoiceBaseOption';
@Injectable({ providedIn: 'root' })
export class InvoiceSetupDataService extends EfaactDataService<InvoiceSetup> {
    mapItems(item: InvoiceSetup): InvoiceSetup {
        return {
            ...item,
            id: item.Ibo_id,
            Status: {
                StatusCode: ResponseStatus.None,
                Message: ''
            }
        };
    }

    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
        this.usePostForQuery = true;
    }
}
